import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { CtExamAttachList } from 'containers';
import { ExamAttachMenu, AdminPageTitle, AdminPageTemplate } from 'components';

class CtAdminExamAttach extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <AdminPageTemplate className="table">
        <AdminPageTitle
          type="table"
          title={defineMessages(formatMessage({ id: 'CtAdminExamTemplate_2', defaultMessage: '첨부파일' }))}>
          {/* <ExamAttachMenu /> */}
        </AdminPageTitle>
        <CtExamAttachList />
      </AdminPageTemplate>
    );
  }
}

CtAdminExamAttach.propTypes = {};
CtAdminExamAttach.defaultProps = {};

export default injectIntl(CtAdminExamAttach);



// WEBPACK FOOTER //
// ./src/script/containers/admin/examAttach/CtAdminExamAttach.js